import { Channel, ChannelMemberIndex } from '../types';
import { channelDisplayName } from '../components/ChannelListItem';

/**
 * 대화방 검색 매칭 규칙 — 대화방 목록(ChatListScreen)과 메시지 전달 모달(ForwardTargetModal)이 공유한다.
 * 두 화면의 동작이 갈라지지 않도록 조건은 반드시 여기 한 곳에만 둔다.
 *
 * 매칭 대상 세 가지:
 *  1. 방 이름 — DM은 서버가 name을 상대방 이름으로 치환해 주므로 대화상대 이름이 곧 방 이름이다
 *  2. 설명 — 그룹 개설 시 입력한 description
 *  3. 참여자 이름 — memberIndex(나 제외, dm/group/private만). 그룹방을 멤버 이름으로 찾는 유일한 경로
 *
 * @param q 호출부에서 trim().toLowerCase()를 마친 검색어. 빈 문자열이면 전부 통과
 */
export function matchesChannelQuery(
  ch: Channel,
  q: string,
  memberIndex?: ChannelMemberIndex,
): boolean {
  if (!q) return true;

  if (channelDisplayName(ch).toLowerCase().includes(q)) return true;
  if (ch.description && ch.description.toLowerCase().includes(q)) return true;

  // 인덱스가 아직 안 왔거나(로딩 중) 서버가 구버전이면 undefined — 이름·설명 검색만으로 동작한다
  const members = memberIndex?.[String(ch.id)];
  if (members && members.some(name => name.toLowerCase().includes(q))) return true;

  return false;
}
